import { render, staticRenderFns } from "./PeakAttributeField.vue?vue&type=template&id=b6b5d888&scoped=true&"
import script from "./PeakAttributeField.vue?vue&type=script&lang=ts&"
export * from "./PeakAttributeField.vue?vue&type=script&lang=ts&"
import style0 from "./PeakAttributeField.vue?vue&type=style&index=0&id=b6b5d888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5d888",
  null
  
)

export default component.exports